import { render, staticRenderFns } from "./ChangePasswordBox.vue?vue&type=template&id=2c27c680&"
import script from "./ChangePasswordBox.vue?vue&type=script&lang=ts&"
export * from "./ChangePasswordBox.vue?vue&type=script&lang=ts&"
import style0 from "./ChangePasswordBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports